import React from 'react';
import {asyncComponent} from 'react-async-component';

export const AsyncSiteFooter = asyncComponent({
    resolve: () => import(
        /* webpackChunkName: "footer" */
        './SiteFooter'
    ),
    LoadingComponent: () => <span />,
    serverMode: 'defer'
});
